import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'page-schedule-select',
  templateUrl: './schedule-select.component.html',
  styleUrls: ['./schedule-select.component.scss']
})
export class ScheduleSelectComponent implements OnInit {

  public title = 'Agenda';

  constructor(
    private readonly router :Router
  ) { }

  ngOnInit(): void {
  }

  goToUrl(page: string) {
    this.router.navigate([page]); 
  }
}
